import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let ViewDesignMethodsRestServiceConfig: IRestfulConfigMap = {
    "viewDesignMethodsRestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取定制面设计模式
            getOne: {
                method: "get",
                path: "api/nodeRuntime/:id/viewDesignMethods",
                testPath: "api/nodeRuntime/:id/viewDesignMethods",
                paramDefaults: {
                    id: "@id"
                }
            },
            // 保存定制面设计模式
            saveDesignMethods: {
                method: "put",
                path: "api/nodeRuntime/:id/viewDesignMethods",
                testPath: "api/nodeRuntime/:id/viewDesignMethods",
                paramDefaults: {
                    id: "@id"
                }
            }
        }
    }
}

export { ViewDesignMethodsRestServiceConfig };